<template>
    <div>

        <!-- Statistieken -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-bar-chart-o"></i>
            </h2>
            <div class="w-100">
                <h2 class="mb-1">
                    Omzet
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#generalStatistics" aria-expanded="true" aria-controls="generalStatistics">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="generalStatisticsSmall">
                <div class="d-sm-flex d-xl-block gap-3 gap-md-5 mt-2 mb-3 mt-sm-3 mb-sm-4 my-xl-0 finance-stats">

                    <div class="d-flex">
                        <p class="mb-0 text-md text-lightgrey fw-medium">
                            {{ this.data.monthName }}
                        </p>
                        <div class="ms-4 d-flex align-items-center gap-4">
                            <span @click="setPrevMonth()" role="button">
                                <i class="fa fa-chevron-left"></i>
                            </span>
                                    <span @click="setNextMonth()" role="button">
                                <i class="fa fa-chevron-right"></i>
                            </span>
                        </div>
                    </div>

                    <div class="total-turnover d-flex align-items-end gap-2 mb-2 mt-2">
                    <span class="round-icon bg-light me-2 me-xl-0" style="width: 27px; height: 27px;">
                        <i class="fa fa-euro"></i>
                    </span>
                        <div>
                            <p class="label mb-0 text-xs fw-medium">
                                Mijn omzet
                            </p>
                            <p class="number mb-0 fw-semibold text-md">
                                {{ this.data.totalMyRevenue }}
                            </p>
                        </div>
                        <span class="percent text-sm fw-semibold">
                        {{ this.data.totalMyRevenuePercentage }}%
                    </span>
                    </div>
                </div>

                <div class="d-sm-flex d-xl-block gap-5">
                    <div class="general-stats col-xl-12 my-xl-3">
                        <h4 class="mb-2">
                            Omzetten per entiteit
                        </h4>
                        <ul class="list-unstyled text-sm fw-medium">
                            <li class="d-flex mb-1 align-items-center">
                                <p class="mb-0 me-3">
                                    Offertes
                                </p>
                                <span class="ms-auto round-icon round-md bg-light">
                                {{ this.data.myTotalOffers }}
                            </span>
                            </li>
                            <li class="d-flex mb-1 align-items-center">
                                <p class="mb-0 me-3">
                                    Project offertes
                                </p>
                                <span class="ms-auto round-icon round-md bg-light">
                                {{ this.data.myTotalOfferProjects }}
                            </span>
                            </li>
                            <li class="d-flex mb-1 align-items-center">
                                <p class="mb-0 me-3">
                                    Webshoporders
                                </p>
                                <span class="ms-auto round-icon round-md bg-light">
                                {{ this.data.myTotalWebshopOrders }}
                            </span>
                            </li>
                            <li class="d-flex mb-1 align-items-center">
                                <p class="mb-0 me-3">
                                    Betaalverzoeken
                                </p>
                                <span class="ms-auto round-icon round-md bg-light">
                                {{ this.data.myTotalPaymentRequests }}
                            </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'general-statistics-small',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: {
                    monthName: '',
                    month: '',
                    year: '',
                    pagination: [{
                        next: {
                            month: '',
                            year: '',
                        },
                        prev: {
                            month: '',
                            year: '',
                        }
                    }],
                    lastYear: '',
                    totalRevenue: '',
                    totalOffersRevenue: '',
                    totalOffersRevenueLastYear: '',
                    totalOffersRevenueLastYearPercentage: '',
                    totalOffers: '',
                    totalOfferProjects: '',
                    totalWebshopOrders: '',

                    totalMyRevenue: '',
                    totalMyRevenuePercentage: '',

                    myTotalOffers: '',
                    myTotalOfferProjects: '',
                    myTotalWebshopOrders: '',
                    myTotalPaymentRequests: '',

                },

                componentId: 'general-statistics-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if(this.componentIsVisable) {
                    this.loading = true;
                    this.getGeneralStatistics();
                }
            },
            getGeneralStatistics() {
                axios.get('api/general-statistics?year='+this.data.year+'&month='+this.data.month)
                    .then(response => {
                       this.data = response.data;

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            setPrevMonth() {
                this.loading = true;
                this.data.year = this.data.pagination.prev.year;
                this.data.month = this.data.pagination.prev.month;
                this.getGeneralStatistics();
            },
            setNextMonth() {
                this.loading = true;
                this.data.year = this.data.pagination.next.year;
                this.data.month = this.data.pagination.next.month;
                this.getGeneralStatistics();
            },
        },
        mounted() {
            if(this.isVisible) {
                this.getGeneralStatistics();
            } else {
                this.loading = false;
            }
        },
        created() {},
    }
</script>
